import React, {Component, ReactNode} from "react"

import {Wrapper} from "./styled/DisablePointerEventsOnScroll"

interface Props {
  children: ReactNode | ReactNode[]
}

interface State {
  scrolling: boolean
}

// https://www.thecssninja.com/css/pointer-events-60fps

export class DisablePointerEventsOnScroll extends Component<Props, State> {
  state: State = {
    scrolling: false
  }

  timeout?: number

  componentDidMount() {
    window.addEventListener("scroll", this.onScrollHandler)
  }

  componentWillUnmount() {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
    window.removeEventListener("scroll", this.onScrollHandler)
  }

  onScrollHandler = () => {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
    this.setState({
      scrolling: true
    })
    this.timeout = window.setTimeout(this.onScrollStop, 200)
  }

  onScrollStop = () => {
    this.timeout = undefined

    this.setState({
      scrolling: false
    })
  }

  render() {
    return <Wrapper isScrolling={this.state.scrolling}>{this.props.children}</Wrapper>
  }
}
